import { errors, worker } from '../services';
export default {
	namespaced: true,
	state: {
		workerQrcode: '',
	},
	mutations: {
		SET_WORKER_QRCODE(state, payload) {
			state.workerQrcode = payload;
		},
	},
	actions: {
		async getWorkerQrcode({ commit }) {
			try {
				const { data, ok } = await worker.getWorkerQrcode();
				if (!ok) {
					return;
				}

				commit('SET_WORKER_QRCODE', data.data);
			} catch (error) {
				errors(error);
			}
		},
	},
};
